const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const classNames = require('classnames');

class MyProfileExtractsMenuButton extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick();
    }

    render() {
        const { label, isActive } = this.props;
        const buttonClass = classNames('extracts-menu__button', {'extracts-menu__button--active': isActive})

        return (
            <button
                className={buttonClass}
                type="button"
                onClick={this.handleClick}
            >
                {label}
            </button>
        );
    }
}

MyProfileExtractsMenuButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool
};

MyProfileExtractsMenuButton.defaults = {
    value: '0',
    isActive: false
}

module.exports = MyProfileExtractsMenuButton;
